import { Card, Image, List, Menu } from "antd";
import React, { Component } from "react";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

class SettingsMenus extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      items: [],
      remaining: [],
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  handleMenuClick = (items) => {
    this.props.navigate("/" + items);
    this.props.closeMenu();
  };

  async componentDidMount() {
    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span className="menu-items-title" style={{ gap: 10 }}>
              <img
                src={require("../assets/images/NewDesign/gear-fill.png")}
                alt="Masters"
                style={{ width: "22px" }}
              />
              {this.context.translate("_SETTINGS_")}
            </span>

            <p
              style={{
                fontSize: "10px",
                marginTop: "5px",
                color: "rgba(255, 255, 255, 0.8)",

                marginBottom: "0px",
              }}
            >
              {this.context.translate("_SETTINGS_DESC_")}
            </p>
          </div>
        ),
      },
    ];

    const remaining2 = [
      {
        key: "notificationlist",
        type: "notificationlist",
        label: (
          <div onClick={() => this.handleMenuClick("notificationlist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/bell-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_NOTIFICATION_LIST_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_NOTIFICATION_TITLE_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "simlist",
        type: "simlist",
        label: (
          <div onClick={() => this.handleMenuClick("simlist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/sim-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_SIM_LIST_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_SIM_LIST_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "deviceloglist",
        type: "deviceloglist",
        label: (
          <div onClick={() => this.handleMenuClick("deviceloglist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/phone-vibrate-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_DEVICE_LOG_LIST_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_DEVICE_LOG_LIST_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "emailmessage",
        type: "emailmessage",
        label: (
          <div onClick={() => this.handleMenuClick("emailmessage")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/envelope-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate(
                "_FLEET_RULEADMIN_RULEDETAIL_EMAILMESSAGE_"
              )}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_EMAIL_MESSAGE_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "inspectionlist",
        type: "inspectionlist",
        label: (
          <div onClick={() => this.handleMenuClick("inspectionlist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/search.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_INSPECTION_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_INSPECTION_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "gprscommand",
        type: "gprscommand",
        label: (
          <div onClick={() => this.handleMenuClick("gprscommand")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/broadcast-pin.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_GPRS_COMMAND_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_GPRS_COMMAND_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "addLocation",
        type: "addLocation",
        label: (
          <div onClick={() => this.handleMenuClick("addLocation")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/geo-alt-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_ADD_LOCATION_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_ADD_LOCATION_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "faqList",
        type: "faqList",
        label: (
          <div onClick={() => this.handleMenuClick("faqList")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/chat-left-dots-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FAQ_LIST_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_FAQ_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "predefinedMesssage",
        type: "predefinedMesssage",
        label: (
          <div onClick={() => this.handleMenuClick("predefinedMesssage")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/chat-text-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_PREDEFINED_MESSAGES_LIST_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_PREDEFINED_MESSAGES_LIST_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "devicelist",
        type: "devicelist",
        label: (
          <div onClick={() => this.handleMenuClick("devicelist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/phone-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FLEET_GROUP_GROUPLIST_TITLE_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_DEVICE_LIST_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "companychangepassword",
        type: "companychangepassword",
        label: (
          <div onClick={() => this.handleMenuClick("companychangepassword")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/shield-lock-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FLEET_MANAGEUSER_CHANGEPASSWORD_TAB_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_CHANGE_PASSWORD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "geofencereportlist",
        type: "geofencereportlist",
        label: (
          <div onClick={() => this.handleMenuClick("geofencereportlist")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Settings/cursor-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_GEOFENCE_MANAGEMENT_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_GEOFENCE_MANAGEMENT_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
    ];

    var remaining=[];
    for (var i = 0; i < remaining2.length; i++) {
      //console.log(remaining2[i].key);
      if(this.props.settingsManagement.includes(remaining2[i].key)){
        remaining.push(remaining2[i]);
      }
    }
    this.setState({ items: items, remaining: remaining });
   
  }
  render() {
    return (
      <div className="tracking-menu-items">
        <div className="tracking-menu-items-list">
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            }}
            items={this.state.items}
          />
        </div>
        <div
          className="tracking-submenu-items-list"
          // style={{
          //   overflow: "scroll",
          //   boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
          //   height: "70vh",
          //   scrollbarWidth: "none",
          // }}
        >
          <Menu
            className="tracking-list-menu"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              alignContent: "flex-start",
              height: "100%",
            }}
            items={this.state.remaining}
            onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
      </div>
    );
  }
}
SettingsMenus.contextType = StoreContext;
export default observer(withRouter(SettingsMenus));
